import React from "react";
import PropTypes from "prop-types";
import { ALL_PROJECTS_ID } from "../constants/projects";

const ProjectSelector = ({ projects, activeProject, onProjectChange }) => {
  if (!projects || projects.length === 0) {
    return <div>No projects found.</div>;
  }

  return (
    <div style={styles.projectSelectorContainer}>
      <select
        id="projectSelector"
        value={activeProject?.id || ""}
        onChange={(e) => onProjectChange(e.target.value)}
        style={styles.select}
      >
        {/* Always first, so the user can broaden to a cross-project view. */}
        <option value={ALL_PROJECTS_ID}>All Projects</option>
        {projects.map((project) => (
          <option key={project.id} value={project.id}>
            {project.projectName}
          </option>
        ))}
      </select>
    </div>
  );
};

const styles = {
  projectSelectorContainer: {
    marginTop: "16px",
  },
  select: {
    backgroundColor: "var(--surface)",
    color: "var(--text)",
    border: "1px solid var(--border)",
    borderRadius: "6px",
    padding: "6px 10px",
    fontSize: "14px",
    cursor: "pointer",
    maxWidth: "60vw",
  },
};

// Define PropTypes for type checking and clarity
ProjectSelector.propTypes = {
  projects: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      projectName: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeProject: PropTypes.shape({
    id: PropTypes.string,
  }),
  onProjectChange: PropTypes.func.isRequired,
};

export default ProjectSelector;
